// External packages
import * as React from 'react';

// Components
import { Card } from 'components/Card';

// Components
import { Button } from 'components/Button';
import { Icon } from 'components/Icons';

// Modules
import { AddAudioModal } from 'modules/audio/AddAudioModal';
import { AudioList } from 'modules/audio/AudioList';

// Hooks
import { useUploadMedia } from 'api/media';

export default function AudioPage() {
  const [modalOpen, setModalOpen] = React.useState(false);

  const { mutate: uploadMedia, isPending: isUploading } = useUploadMedia();

  return (
    <Card className="flex flex-col h-full min-h-[calc(100vh-9rem)] md:min-h-[calc(100vh-8rem)]">
      <div className="flex items-center justify-between gap-x-8 gap-y-4">
        <h1 className="text-2xl text-gray-600">Audio</h1>
        <AddAudioModal
          isOpen={modalOpen}
          onOpenChange={setModalOpen}
          onSubmit={(data) => {
            uploadMedia(
              { file: data.audio, fileType: 'audio' },
              {
                onSuccess: () => setModalOpen(false),
              }
            );
          }}
          modalTrigger={
            <Button icon={<Icon name="plus" />}>Dodaj audio</Button>
          }
          isPending={isUploading}
        />
      </div>
      <hr className="my-6 h-px text-gray-200" />
      <AudioList />
    </Card>
  );
}
